import { Translate, withI18n } from "@quantum/i18n";
import React, { useEffect } from "react";
import { compose } from "recompose";
import { connect } from "react-redux";
import { SelectInput } from "../../../comum";
import SelecaoFrequencia from "./indicadoresFinanceiros/SelecaoFrequencia";
import { ID_PERIODO_ANO_A_ANO } from "../../../../model";
import { comEdicaoDeMedida } from "../../Contexto";

import {
  getAnos,
  getAnosSelecionados,
  getPeriodosSelecionados,
  selecionarAnos,
  selecionarPeriodo,
} from "../../../../state";
import equals from "ramda/src/equals";

type Props = {
  listaAnos: Array<Id>,
  anosSelecionados: Array<Id>,
  periodosSelecionados: Array<id>,
  selecionarAnos: ActionCreator,
  selecionarPeriodo: ActionCreator,
  desmarcarTodosAnos: ActionCreator,
};

const periodo = [ID_PERIODO_ANO_A_ANO];

function SelecaoPeriodoTrimestres({
  listaAnos,
  anosSelecionados,
  periodosSelecionados,
  selecionarAnos,
  selecionarPeriodo,
  desmarcarTodosAnos,
}: Props) {
  useEffect(() => {
    if (!equals(periodosSelecionados, periodo)) {
      selecionarPeriodo([ID_PERIODO_ANO_A_ANO]);
    }
  }, [selecionarPeriodo, periodosSelecionados]);

  return (
    <>
      <div className="ConfiguracaoMedida">
        <label className="ConfiguracaoMedida__label">
          <Translate>maiusculas.periodo</Translate>
          {anosSelecionados.length >= 1 && (
            <span
              className="ConfiguracaoMedida__label--desmarcar"
              onClick={desmarcarTodosAnos}
            >
              <Translate>Comum.desmarcarTodos</Translate>
            </span>
          )}
        </label>
        <SelectInput
          onChange={selecionarAnos}
          value={anosSelecionados}
          options={listaAnos}
          size={10}
          multiple={true}
          campoId={"codigo"}
          campoDescricao={"descricao"}
        />
      </div>
      <div className="ConfiguracaoMedida__box">
        <div className="ConfiguracaoMedida__box">
          <SelecaoFrequencia />
        </div>
      </div>
    </>
  );
}

export default compose(
  withI18n,
  comEdicaoDeMedida,
  connect(
    (state, ownProps) => ({
      listaAnos: getAnos(state),
      anosSelecionados: getAnosSelecionados(state),
      periodosSelecionados: getPeriodosSelecionados(state),
    }),
    {
      desmarcarTodosAnos: () => selecionarAnos([]),
      selecionarAnos,
      selecionarPeriodo,
    }
  )
)(SelecaoPeriodoTrimestres);
